<template>
  <div class="deta">

    <mu-tabs :value.sync="active"
             @change="tabChange"
             class="tab"
             inverse
             color="#3B9CFD"
             indicator-color="#3B9CFD"
             center>
      <mu-tab>报告详情</mu-tab>
<!--      <mu-tab>随访建议</mu-tab>-->
    </mu-tabs>


    <div class="main" v-show="active == 0" >
      <div class="main_report">
        <div class="main_report_people">
          <p class="people_title">就诊人</p>
          <div class="people">
            <div class="people_left">
              <h2 style="font-size: 1rem;">{{ info.name }}</h2>
              <p v-if="info.gender == 0">女</p>
              <p v-if="info.gender == 1">男</p>
            </div>
            <ul class="people_ul">
              <li>
                <p>手机号</p>
                <span>{{ info.phoneNo }}</span>
              </li>
              <li>
                <p>身份证号</p>
                <span>{{ info.idCardNo }}</span>
              </li>
            </ul>
          </div>
        </div>
        <div class="report_img">
          <div style="display: flex; justify-content: space-between; align-items: center;">
            <p style="line-height: 24px;" class="people_title">报告详情</p>
<!--            <p style="margin-bottom: 0.75rem;line-height: 1.5rem;font-size: 0.75rem;">报告加载时间过长请耐心等待</p>-->
          </div>
<!--          <ul class="people_ul"-->
<!--              style="margin-bottom: 10px"-->
<!--              @click="link_pdf(item)"-->
<!--              :key="item"-->
<!--              v-for="item in numPages">-->
<!--            <pdf class="pdf"-->
<!--                 :page="item"-->
<!--                 :src="info.pdfurl"></pdf>-->
<!--          </ul>-->

          <template v-if="info.imgs!= null && info.imgs.length != 0">
            <ul class="img" >
              <li v-for="(item,index) in info.imgs" :key="index" @click="getImg(index)" >
                <van-image :src="item" alt=""/>
              </li>
            </ul>
          </template>
          <template v-else>
            <NoList>
              <template #text>
                <p>暂无报告详情</p>
              </template>
            </NoList>
          </template>

        </div>
      </div>
    </div>


    <ul class="main_porp" v-show="active == 1" >
      <template v-if="deta.followAdviceList.length != 0">
        <li class="main_porp_li">
          <div class="title">
            <p class="blue">{{ deta.reportType != null ? $store.state.type.filter((item) => { return item.dictKey == deta.reportType })[0].dictValue : null }}报告</p>
            <p>{{ deta.createTime }}</p>
          </div>
          <ul class="content" v-for="(item,index) in deta.followAdviceList" :key="index"  >
            <li>
              <h2>{{ index+1 }}.{{ item.deptName }}</h2>
              <div class="reason" v-for="(items,indexs) in item.adviceList" :key="indexs" >
                <p>
                  <span>诊断原因</span>
                  {{ items.reason }}
                </p>
                <p>
                  <span>医生建议</span>
                  {{ items.advice }}
                </p>
                <p>
                  <span>建议复诊时间</span>
                  {{ items.reviewDate }}
                </p>
              </div>
            </li>
          </ul>
          <div class="button">
            <mu-button @click="link_followDeta($route.query.id)" color="primary" round >预约复诊</mu-button>
          </div>
        </li>
      </template>
      <template v-else>
        <NoList>
          <template #text>
            <p style="text-align:center;">如出现任何身体不适，请随时到医院就医。</p>
          </template>
        </NoList>
      </template>
    </ul>

    <Pdf
        v-if="showPdf"
        :parent="this"
        :show.sync="showPdf"
        :showName="'showPdf'"
        :control="true"
        :currentPages="page_pdf"
        :dochref="pdfHref"></Pdf>


  </div>
</template>

<script>
import pdf from 'vue-pdf'
export default {
  name: "ReportDeta",
  data() {
    return {
      active: 0,
      info: {
        pdfurl: []
      },
      // 随访建议
      deta: {
        followAdviceList: [],
      },
      numPages: [],
      show: false,
      page_pdf: 1,
      showPdf: false,
      pdfHref: ""
    }
  },
  watch: {
    "showPdf": function (newValue) {
      console.log(newValue)
      if(newValue) {
        this.stop()
      }else {
        this.move()
      }
    }
  },
  created() {
    this.get_list(this.$route.query.id);
    this.get_deta(this.$route.query.id);
    this.$store.dispatch("setType");
  },
  mounted() {

  },
  methods: {
    getImg(e) {
      this.$ImagePreview({
        images: this.info.imgs,
        startPosition: e,
      });
    },
    link_pdf(e) {
      this.page_pdf= e;
      this.showPdf= true;
    },
    //禁止滚动
    stop(){
      var mo=function(e){e.preventDefault();};
      document.body.style.overflow='hidden';
      document.addEventListener("touchmove",mo,false);//禁止页面滑动
    },
    /***取消滑动限制***/
    move(){
      var mo=function(e){e.preventDefault();};
      document.body.style.overflow='';//出现滚动条
      document.removeEventListener("touchmove",mo,false);
    },
    getNumPages(url) {
      let loadingTask = pdf.createLoadingTask(url)
      loadingTask.promise.then(pdf => {
        this.numPages = pdf.numPages;
        console.log(this.numPages);
      }).catch(err => {
        console.error('pdf 加载失败', err);
      })
    },
    get_list(y) {
      this.$get("report/detail",y,true)
        .then(res => {
          if(res) {
            console.log(res);
            this.info= res.data;


            // this.getNumPages(res.data.pdfurl);
            // this.$nextTick(() => {
            //   this.pdfHref= res.data.pdfurl;
            // })
          }
        })
    },
    get_deta(y) {
      this.$get("follow",y,true)
        .then(res => {
          if(res) {
            console.log(res);
            this.deta= res.data;
          }
        })
    },
    link_followDeta(e) {
      console.log(e)
      this.$router.push({
        path: "/FollowDeta",
        query: {
          id: e
        }
      })
    },
    image(e) {
      this.$ImagePreview(e);
    },
    tabChange() {

    }
  },
  components: {
    pdf
  }
}
</script>

<style lang="less" scoped>
  @import "../../style/Report/ReportDeta";
</style>
